"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullPageOverlay = exports.BlurredOverlay = void 0;
const react_1 = __importDefault(require("react"));
const rn_css_1 = __importDefault(require("rn-css"));
const react_native_1 = require("react-native");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const expo_blur_1 = require("expo-blur");
const BlurredOverlay = ({ active, children }) => {
    const { height, width } = (0, react_native_1.useWindowDimensions)();
    const theme = (0, base_ui_theme_themes_1.useTheme)();
    if (!active) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BlurredBG, { height: height, width: width, intensity: 60, tint: theme.mode }),
        react_1.default.createElement(ColorBG, { color: theme.mode === "dark" ? "white" : "black", height: height, width: width }),
        react_1.default.createElement(StyledOverlayView, null, children)));
};
exports.BlurredOverlay = BlurredOverlay;
const FullPageOverlay = ({ active, children }) => {
    if (!active) {
        return null;
    }
    return (react_1.default.createElement(StyledOverlayView, null, children));
};
exports.FullPageOverlay = FullPageOverlay;
const BlurredBG = (0, rn_css_1.default)(expo_blur_1.BlurView) `
    position: fixed;
    z-index: 997;
    top: 0;
    left: 0;
    height: ${state => state.height};
    width: ${state => state.width};
    backdrop-filter: blur(10em);
    -webkit-backdrop-filter: blur(10em);
`;
const ColorBG = rn_css_1.default.View `
    position: fixed;
    z-index: 998;
    top: 0;
    left: 0;
    height: ${state => state.height};
    width: ${state => state.width};
    background-color: ${state => state.color};
    opacity:0.3;
`;
const StyledOverlayView = rn_css_1.default.View `
    position: fixed;
  
    top : 50%;
    left : 50%;
    transform : translate(-50%,-50%);
    
    z-index: 999;
    
    /* Enable scroll if needed */
    overflow: auto;
`;
//# sourceMappingURL=overlays.js.map